import { useState } from "react";
import LandingList from "./LandingList";
import CreateLanding from "./createLanding";
import SidebarAdmin from './../composant/sideBarAdmin'

export default function Index() {
  const [editSlug, setEditSlug] = useState(null);

  return (
    
    <div>
      <section id="content">
      <SidebarAdmin/>
      <main>
      <LandingList
        onEdit={(slug) => {
          console.log("App recebeu slug para editar:", slug);
          setEditSlug(slug); // ✅ atualiza estado
          window.scrollTo({ top: 0, behavior: "smooth" }); // opcional UX
        }}
      />

      <CreateLanding editSlug={editSlug} />
      </main>
      </section>
    </div>
  );
}
